var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorHome160)",
    d: "M6 9h4v5H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorHome161)",
    d: "M8.687 2.273a1 1 0 0 0-1.374 0l-4.844 4.58A1.5 1.5 0 0 0 2 7.943v4.569a1.5 1.5 0 0 0 1.5 1.5h3v-4a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v4h3a1.5 1.5 0 0 0 1.5-1.5v-4.57a1.5 1.5 0 0 0-.47-1.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorHome162)",
    fillRule: "evenodd",
    d: "m8.004 2.636l5.731 5.41a.75.75 0 1 0 1.03-1.091L8.86 1.382a1.25 1.25 0 0 0-1.724.007L1.23 7.059a.75.75 0 0 0 1.038 1.082z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fluentColorHome160",
    x1: 8,
    x2: 4.796,
    y1: 9,
    y2: 14.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#944600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cd8e02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fluentColorHome161",
    x1: 3.145,
    x2: 14.93,
    y1: 1.413,
    y2: 10.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb357"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fluentColorHome162",
    x1: 10.262,
    x2: 6.945,
    y1: -0.696,
    y2: 7.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff921f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb4824"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.0e4a27ada6fe14c442dd015d8e7ca3de.svg";
export { ForwardRef as ReactComponent };